(function($, window, document, s, undefined){


  var initModalButtons = function initModalButtons() {
    s.$doc.on('click', '.modal-link', function (e){
      e.preventDefault();

      var $modal = $('.modal' + $(e.target).data('modal'));

      if (!$modal) return;

      $modal
        .removeClass('hidden')
        .removeClass('invisible')
        .niceScroll({
          zindex: 4000,
          autohidemode: false,
          cursorwidth: 8,
          cursorcolor: '#c3c3bd',
          railpadding: {
            top: 80,
            right: 44,
            bottom: 15
          }
        });

      s.callOnResize(function(){
        $modal.getNiceScroll().resize();
      });

      $modal.find('.close-btn').on('click', function (){
        $modal
          .addClass('invisible')
          .delay(150)
          .addClass('hidden');
      });
    });
  };


  /**
  * Initializes the opening of modals for appropriate buttons (initModalButtons)
  * and checks the url for hashes, singifying a modal should open.
  */
  var checkForModals = function checkForModals() {
    var modalHash = window.location.hash;
    var $modalLink = null;

    initModalButtons();

    if (modalHash.indexOf('#modal-' === 0)) {
      $modalLink = $('#' + modalHash.substr(7));

      if ($modalLink.length) {
        setTimeout(function(){
          $modalLink.click();
        }, 500);
      }
    }
  };


  var initWindowOpeners = function initWindowOpeners() {
    $('.small-window-opener').on('click', function(e) {
      e.preventDefault();
      window.open($(this).attr('href'), 'Share ' + document.title, 'height=570, width=800');
    });
  };

  s.callOnReady(checkForModals);
  s.callOnReady(initWindowOpeners);

})(jQuery, this, this.document, window.s);
